import React, { useContext, useState } from 'react';
import { c as classnames } from './index-2586sEvh.js';
import get from 'lodash/get';
import { useTranslation } from 'next-i18next';
import { CoreContext } from './context/index.js';

const SelectComponent = ({ register, id, errors, name, options, label, disabled, variant = 'stacked', ariaLabel = '', onChangeCallback, }) => {
    var _a;
    const { t } = useTranslation('');
    const errorText = get(errors, `${name}.message`, '');
    const isError = Boolean(errorText);
    const registerField = register(name);
    const { data: { siteConfig: { product: { outsideLabels = false } = {} }, }, } = useContext(CoreContext);
    const selectOptions = outsideLabels
        ? [
            {
                value: '',
                label: t('$pages.$product.sizeFieldPlaceholder'),
            },
            ...options,
        ]
        : options;
    const [selectedValue, setSelectedValue] = useState(((_a = selectOptions.find(({ selected }) => selected)) === null || _a === void 0 ? void 0 : _a.value) || selectOptions[0].value);
    const onChange = (e) => {
        registerField.onChange(e);
        const { value } = e.target;
        setSelectedValue(value);
        if (typeof onChangeCallback === 'function') {
            onChangeCallback();
        }
    };
    return (React.createElement("div", { className: `form-control ${variant}-input` },
        label && (React.createElement("label", { htmlFor: id, className: "label" }, label)),
        React.createElement("div", { className: "form-control-wrapper" },
            React.createElement("select", { ...registerField, id: id, "data-testid": id, disabled: disabled, className: classnames('select custom-focus', { error: isError }), "aria-label": ariaLabel, onChange: onChange, "aria-invalid": isError ? 'true' : 'false', "aria-describedby": isError ? `${id}Error` : undefined, value: selectedValue }, selectOptions.map(({ value, label: labelName, disabled: disabledOption }, index) => (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement("option", { "data-testid": value, key: index, value: value, disabled: disabledOption }, labelName)))),
            isError && (React.createElement("div", { className: "error", id: `${id}Error`, role: "alert" }, t(errorText))))));
};

export { SelectComponent as S };
//# sourceMappingURL=Select-LSn3KQwG.js.map
